import React, { useEffect, useState } from "react";
import slide1 from "../assets/1.jpg";
import slide2 from "../assets/2.jpg";
import slide3 from "../assets/3.jpg";

function Slideshow() {
  const slides = [slide1, slide2, slide3];
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div
      className="slideshow-container"
      style={{
        position: "relative", // Ensure the container is the reference for absolute positioning
        width: "100%",
        maxWidth: "100%",
        overflow: "hidden",
        height: "auto", // Adjust height dynamically based on the image
      }}
    >
      {slides.map((slide, index) => (
        <div
          key={index}
          className="slide"
          style={{
            display: currentSlide === index ? "block" : "none",
            width: "100%",
            height: "100%", // Ensure the slide takes the full height of the container
          }}
        >
          <img
            src={slide}
            alt={`Slide ${index + 1}`}
            className="responsive-image"
            style={{
              width: "100%",
              height: "auto", // Maintain aspect ratio
              display: "block",
            }}
          />
        </div>
      ))}
      {/* Previous Button */}
      <div
        className="prev"
        onClick={() => setCurrentSlide((currentSlide - 1 + slides.length) % slides.length)}
        style={{
          position: "absolute",
          top: "50%",
          left: "10px",
          transform: "translateY(-50%)",
          fontSize: "24px",
          color: "#000",
          backgroundColor: "rgba(255, 255, 255, 0.7)",
          border: "none",
          cursor: "pointer",
          zIndex: 10,
          padding: "10px",
          borderRadius: "50%",
          userSelect: "none",
        }}
      >
        &#10094;
      </div>
      {/* Next Button */}
      <div
        className="next"
        onClick={() => setCurrentSlide((currentSlide + 1) % slides.length)}
        style={{
          position: "absolute",
          top: "50%",
          right: "10px",
          transform: "translateY(-50%)",
          fontSize: "24px",
          color: "#000",
          backgroundColor: "rgba(255, 255, 255, 0.7)",
          border: "none",
          cursor: "pointer",
          zIndex: 10,
          padding: "10px",
          borderRadius: "50%",
          userSelect: "none",
        }}
      >
        &#10095;
      </div>
    </div>
  );
}

export default Slideshow;